import React from 'react';
import { Constants } from '../../../../../constants';
import Helpers from '../../../../../constants/helpers';
import { UpsellPanelSteps } from '../../../../../constants/upsellPanelEnumsAndConstants';
import { useAuth } from '../../../../../hooks/useAuth';
import { useUpsellWidgetContainer } from '../../../hooks/useUpsellWidgetContainerContext';
import { useUpsellWidgetModel } from '../../../hooks/useUpsellWidgetModelContext';

export const Step4MobileUpdateHeaderContent = () => {
    const { isAuthenticated } = useAuth();
    const model = useUpsellWidgetModel();
    const { currentStep, baseProps, headerFontClass  } = useUpsellWidgetContainer();

    if (currentStep !== UpsellPanelSteps.Step4MobileUpdate) {
        return null;
    }

    const mobileText = isAuthenticated && model.mobileText ? model.mobileText : "Please enter your mobile number and press send to receive a text message with a verification code.";

    return (
        <>
            <h2 className={`mb-2 ${headerFontClass} pt-48-sm-down font-circular-std-bold`}>
                {baseProps.completedStep1 ? Constants.UPSELL_TRIAL_HEADING : model.content.trialHeading.replace('{0}', baseProps.user.firstName)}
            </h2>
            <div className="color-gray-16 font-19 mb-3">{mobileText}</div>
            <div className={`py-32 ${model.UsePopupOverlay ? " verification-step" : ""}`}>
                <img src={Helpers.getBlobFileUrl("/images/Verification-step-2.webp")} alt="mobile update" title="mobile update" />
            </div>
        </>
    );
};
